import axios from 'axios';
import { appointmentServiceApi } from '../../../config/config';
import { setupInterceptorsTo } from '../interceptors/axios.interceptos';

const axiosInstance = setupInterceptorsTo(axios.create());

export interface PatientInvoiceLogEntry {
    to: string,
    sendOn: string
}

export interface PatientInvoice {
    email: string,
    logs: PatientInvoiceLogEntry[]
}

/**
 * Pulls the reason out of the appointment service's { error } body so the user
 * sees why a send was refused - e.g. the practitioner not having the invoice
 * feature enabled - rather than a generic failure.
 */
const errorFrom = (error: any, fallback: string): Error =>
    new Error(error?.response?.data?.error || fallback);

class InvoiceService {

    /**
     * Address to pre-fill the resend dialog with, plus the invoices already
     * sent for this appointment.
     */
    async getPatientInvoice(apptId: number | string): Promise<PatientInvoice> {
        const { data } = await axiosInstance.get(
            `${appointmentServiceApi.baseUrl}/api/v1/appointment/${apptId}/invoice`
        );
        return {
            email: data?.data?.email ?? '',
            logs: data?.data?.logs ?? []
        };
    }

    /**
     * Re-send the online consultation invoice to the given address.
     */
    async resendPatientInvoice(apptId: number | string, email: string): Promise<void> {
        try {
            await axiosInstance.post(
                `${appointmentServiceApi.baseUrl}/api/v1/appointment/${apptId}/invoice/send`,
                { email }
            );
        } catch (error) {
            throw errorFrom(error, 'Unable to send the invoice. Please try again.');
        }
    }
}

const invoiceService = new InvoiceService();
export default invoiceService;
